// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2e_EL","colCheckbox":"styles_colCheckbox__2RuQ-"};